import { createReducer, on } from '@ngrx/store';

import { EvseOverviewResponseStoreModel, VehicleOverviewResponseStoreModel } from '@domain/single-site/single-site.models';

import {
  clearSingleSiteData,
  loadEvseOverview,
  loadEvseOverviewFailure,
  loadEvseOverviewSuccess,
  loadVehicleOverview,
  loadVehicleOverviewFailure,
  loadVehicleOverviewSuccess,
  setAssetDetailsDialogWide,
  vehicleOverviewSocketMessageArrive,
} from './single-site.actions';

export interface SingleSiteState {
  assetDetailsDialogWide: boolean;

  evseOverview?: EvseOverviewResponseStoreModel;
  evseOverviewIsLoading?: boolean;
  evseOverviewError?: string;

  vehicleOverview?: VehicleOverviewResponseStoreModel;
  vehicleOverviewIsLoading?: boolean;
  vehicleOverviewError?: string;
}

export const initialState: SingleSiteState = {
  assetDetailsDialogWide: false,
};

export const singleSiteFeatureKey = 'singleSite';

export const singleSiteReducer = createReducer(
  initialState,

  on(setAssetDetailsDialogWide, (state, { wide }): SingleSiteState => ({ ...state, assetDetailsDialogWide: wide })),

  on(loadEvseOverview, (state): SingleSiteState => ({ ...state, evseOverviewIsLoading: true, evseOverviewError: undefined })),
  on(
    loadEvseOverviewSuccess,
    (state, { evseOverview }): SingleSiteState => ({
      ...state,
      evseOverviewIsLoading: false,
      evseOverview,
    })
  ),
  on(
    loadEvseOverviewFailure,
    (state, { error }): SingleSiteState => ({
      ...state,
      evseOverviewIsLoading: false,
      evseOverviewError: error,
    })
  ),

  on(loadVehicleOverview, (state): SingleSiteState => ({ ...state, vehicleOverviewIsLoading: true, vehicleOverviewError: undefined })),
  on(
    loadVehicleOverviewSuccess,
    (state, { vehicleOverview }): SingleSiteState => ({
      ...state,
      vehicleOverviewIsLoading: false,
      vehicleOverview,
    })
  ),
  on(
    loadVehicleOverviewFailure,
    (state, { error }): SingleSiteState => ({
      ...state,
      vehicleOverviewIsLoading: false,
      vehicleOverviewError: error,
    })
  ),
  on(
    vehicleOverviewSocketMessageArrive,
    (state, { message }): SingleSiteState => ({
      ...state,
      vehicleOverview: {
        ...state.vehicleOverview!,
        statusData: {
          ...state.vehicleOverview!.statusData,
          ...message.statusData,
        },
      },
    })
  ),

  on(clearSingleSiteData, (): SingleSiteState => initialState)
);
